export const API_URL = process.env.REACT_APP_API_URL; // PROD https://kfpapi.investmentbox.ru
export const SESSION_URL = process.env.REACT_APP_SESSION_URL;
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const PROFINANSY_URL = process.env.REACT_APP_PROFINANSY_URL;
export const PDF_URL = process.env.REACT_APP_PDF_URL;
export const PDF_GENERATE_URL = process.env.REACT_APP_PDF_GENERATE_URL;
export const SERVICE_URL = process.env.REACT_APP_SERVICE_URL;
export const LMS_URL = process.env.REACT_APP_LMS_URL;
